import { useContext } from "react";
import gql from "graphql-tag";
import { intlContext } from "translations/context";
import { NaturalPersonState } from "types/NaturalPerson";
import { apolloClient } from "utils";
import IStepObject from "../../types/IStepObject";
import { IDataCompletionVerificationInput } from "../../types/registerArgs";

export default function useStepVerification(): IStepObject<IDataCompletionVerificationInput> {
  const { translate } = useContext(intlContext);

  return {
    registerFn: dispatchNaturalPersonEvent,
    stepId: NaturalPersonState.verification,
    title: translate("data_completion_verification_title")
  };
}

const mutation = gql`
  mutation dispatchNaturalPersonEvent($naturalPersonId: ID, $payload: JSON!) {
    dispatchNaturalPersonEvent(event: { type: submitVerification, naturalPersonId: $naturalPersonId, payload: $payload })
  }
`;

async function dispatchNaturalPersonEvent(naturalPersonId: string, args: IDataCompletionVerificationInput): Promise<void> {
  await apolloClient.cache.reset();
  const response = await apolloClient.mutate({
    mutation,
    variables: { naturalPersonId, payload: args },
    fetchPolicy: "no-cache"
  });
  if (response.errors) throw response.errors;
}
